import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Row, Col, Radio, Button, DatePicker, Popover, Form, Input, Drawer } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import { FaExchangeAlt, FaMinus, FaRegTimesCircle, FaTimes, FaPlus, FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { fetchFlightCountryList } from '../../../redux/flight/flightSearchListSlice';
import { topTanCity, travelersClass } from '../../../utils/Constants';
import { icons } from '../../../assets/iconsPath';

const SearchBar = ({
    roundTrip,
    crossReturnDate,
    selectAdults,
    selectchildren,
    selectInfants,
    returnFlight,
    removeAdults,
    addAdults,
    removeInfants,
    addInfants,
    removeChildern,
    addChildern,
    seatType,
    setSeatType,
    infantsError,
    errorSameCitySelect,
    setErrorSameCitySelect,
    selectedFrom,
    setSelectedFrom,
    selectedTo,
    setSelectedTo,
    showSearchListFrom,
    setShowSearchListFrom,
    showSearchListTo,
    handleSelectFromFlight,
    setShowSearchListTo,
    handleSelectToFlight,
    setTopCityData,
    topCityData,

    findDay,
    setFindDay,
    findDayRetrun,
    setFindDayRetrun,
    dateFormat,
    isReturnDrawerOpen,
    setIsReturnDrawerOpen,
    isDrawerOpen,
    setIsDrawerOpen,
    searchTermFrom,
    setSearchTermFrom,
    searchTermTo,
    setSearchTermTo,
    validationError,
    fieldErrors,
}) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { flightList } = useSelector((state) => state.flightList);
    const [isDatePickerOpen1, setIsDatePickerOpen1] = useState('');
    const [isDatePickerOpen1Return, setIsDatePickerOpen1Return] = useState('');
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [isDatePickerOpenReturn, setIsDatePickerOpenReturn] = useState(false);
    const datePickerRef = useRef(null);
    const wrapperRef = useRef(null);
    const datePickerRefReturn = useRef(null);
    const wrapperRefReturn = useRef(null);

    const onChangeDeparture = (date, dateString) => {
        setIsDatePickerOpen1(dateString);
        setFindDay(dateString);
        const selectedDate = dayjs(dateString, dateFormat);
        const currentReturnDate = new Date(findDayRetrun)
        if (!findDayRetrun || selectedDate >= currentReturnDate) {
            const updatedReturnDate = selectedDate.add(1, 'day').format(dateFormat);
            setFindDayRetrun(updatedReturnDate);
        }
        setIsDatePickerOpen(false);
        if (returnFlight === "roundTrip") {
            setTimeout(() => {
                setIsDatePickerOpenReturn(true);
            }, 100);
        }
    };

    const handleDivClick = () => {
        setIsDatePickerOpen(true);
        setIsDatePickerOpenReturn(false);
    };

    const handleDivClickReturn = () => {
        setIsDatePickerOpenReturn(true);
        setIsDatePickerOpen(false);
    };

    const handleClickOutside = (event) => {

        if (
            datePickerRef.current instanceof HTMLElement &&
            !datePickerRef.current.contains(event.target) &&
            wrapperRef.current instanceof HTMLElement &&
            !wrapperRef.current.contains(event.target)
        ) {
            setIsDatePickerOpen(false);
        }

        // Check if datePickerRefReturn and wrapperRefReturn are attached to a valid DOM element
        if (
            datePickerRefReturn.current instanceof HTMLElement &&
            !datePickerRefReturn.current.contains(event.target) &&
            wrapperRefReturn.current instanceof HTMLElement &&
            !wrapperRefReturn.current.contains(event.target)
        ) {
            setIsDatePickerOpenReturn(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setIsDatePickerOpen(false);
        setIsDatePickerOpenReturn(false);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDatePickerOpen1, isDatePickerOpen1Return]);

    const onChangeReturn = (date, dateString) => {
        setIsDatePickerOpen1Return(dateString)
        setFindDayRetrun(dateString);
    };

    const disabledPastDate = (current) => {
        return current && current < moment().startOf('day');
    };

    const popoverFromRef = useRef(null);
    const popoverToRef = useRef(null);

    const debounce = (func, delay) => {
        let debounceTimer;
        return function (...args) {
            const context = this;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    };

    const fetchCountryList = useCallback(
        debounce((term) => {
            dispatch(fetchFlightCountryList(term));
        }, 500),
        []
    );

    useEffect(() => {
        if (showSearchListFrom) {
            fetchCountryList(searchTermFrom);
        }
    }, [showSearchListFrom, searchTermFrom, fetchCountryList]);

    useEffect(() => {
        if (showSearchListTo) {
            fetchCountryList(searchTermTo);
        }
    }, [showSearchListTo, searchTermTo, fetchCountryList]);


    const showSearchFrom = () => {
        setShowSearchListFrom(!showSearchListFrom);
        setShowSearchListTo(false);
        setTopCityData(true)
        sessionStorage.removeItem('Indigo');
        if (!showSearchListFrom) {
            fetchCountryList(searchTermFrom);
        }
    };

    const showSearchTo = () => {
        setShowSearchListTo(!showSearchListTo)
        setShowSearchListFrom(false);
        setTopCityData(true)
        sessionStorage.removeItem('Indigo');
        if (!showSearchListTo) {
            fetchCountryList(searchTermTo);
        }
    };

    const handleInputChange = (e) => {
        setSearchTermFrom(e.target.value);
        fetchCountryList(e.target.value);
        setTopCityData(e.target.value === '');
        setErrorSameCitySelect(false)
    };

    const handleInputToChange = (e) => {
        const value = e.target.value;
        setSearchTermTo(value);
        fetchCountryList(value);
        setTopCityData(value === '');
        setErrorSameCitySelect(false)
    };

    const handleExchange = () => {
        const temp = { ...selectedFrom };
        setSelectedFrom(selectedTo);
        setSelectedTo(temp);
    };


    useEffect(() => {
        setErrorSameCitySelect(false);
    }, [selectedFrom, selectedTo]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverFromRef.current && !popoverFromRef.current.contains(event.target)) {
                setShowSearchListFrom(false);
                setTopCityData(true)
                setErrorSameCitySelect(false)
                setErrorSameCitySelect(false);
            }
            if (popoverToRef.current && !popoverToRef.current.contains(event.target)) {
                setShowSearchListTo(false);
                setTopCityData(true)
                setErrorSameCitySelect(false);
                setErrorSameCitySelect(false)
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const contentStyle = {
        padding: 50,
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 4,
    };
    const LoaderContent = <div style={contentStyle} />;

    const inputRef = useRef(null);

    useEffect(() => {
        if (showSearchListFrom && inputRef.current) {
            inputRef.current.focus();
        }
        if (showSearchListTo && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showSearchListFrom, showSearchListTo]);

    const totalPassengers = selectAdults + selectchildren + selectInfants;
    const [passengerLimitReached, setPassengerLimitReached] = useState(null);

    useEffect(() => {
        if (totalPassengers >= 12) {
            setPassengerLimitReached(true);
        } else {
            setPassengerLimitReached(false);
        }
    }, [totalPassengers]);

    useEffect(() => {
        const handleScrollDisable = () => {
            const isMobile = window.innerWidth <= 768;
            if (isMobile && (showSearchListFrom || showSearchListTo)) {
                document.body.classList.add("disable-scroll");
            } else {
                document.body.classList.remove("disable-scroll");
            }
        };

        handleScrollDisable(); // Call on component render
        window.addEventListener("resize", handleScrollDisable); // Handle screen resize

        return () => {
            document.body.classList.remove("disable-scroll"); // Clean up on unmount
            window.removeEventListener("resize", handleScrollDisable);
        };
    }, [showSearchListFrom, showSearchListTo]);




    const today = moment();

    const generateCalendarReturn = () => {
        const calendar = [];
        const endOfYear = today.clone().add(1, "year").endOf("year");
        let current = today.clone().startOf("month");

        while (current.isBefore(endOfYear, "month")) {
            const daysInMonth = current.daysInMonth();
            const startDay = current.clone().startOf("month").day();

            const monthData = {
                month: current.format("MMMM YYYY"),
                days: [],
            };

            for (let i = 0; i < startDay; i++) {
                monthData.days.push(null);
            }

            for (let day = 1; day <= daysInMonth; day++) {
                const date = current.clone().date(day);
                monthData.days.push(date);
            }

            calendar.push(monthData);
            current.add(1, "month");
        }

        return calendar;
    };

    const calendarData = generateCalendarReturn();

    const handleDateSelect = (date) => {
        if (!date || date.isBefore(today, "day")) return;
        setFindDay(date.format("DD/MMM/YYYY"));
        setIsDrawerOpen(false);
        setFindDayRetrun(date.format("DD/MMM/YYYY"));
        setIsReturnDrawerOpen(true);
    };

    const handleReturnDateSelect = (date) => {
        const departureDate = moment(findDay, "DD/MMM/YYYY");
        if (!date || !departureDate || date.isBefore(departureDate, "day")) return;
        const weekday = date.format("dddd");
        setFindDayRetrun(date.format("DD/MMM/YYYY"));
        setIsReturnDrawerOpen(false);
    };

    const filteredCalendarData = calendarData.filter((month) => {
        const firstDate = month.days.find((date) => date);
        return firstDate && firstDate.isSameOrAfter(today, "month");
    });

    const filteredReturnCalendarData = calendarData.filter((month) => {
        const firstDate = month.days.find((date) => date);
        const departureDate = findDay ? moment(findDay, "DD/MMM/YYYY") : null;
        return (
            firstDate &&
            departureDate &&
            firstDate.isSameOrAfter(departureDate, "month")
        );
    });


    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);




    return (
        <>

            <Row gutter={16}>
                <Col lg={10} className='w-100 from_to_box pe-md-0'>
                    <Row gutter={16} className="flight_change">
                        <Col lg={12} xs={12} className='w-100 flight_from_box pe-1'>
                            {/* From Box */}
                            {/* <div className='flight_from cursor-pointer' */}
                            <div className={`flight_from cursor-pointer ${fieldErrors.from.hasError ? 'flight-field-error' : ''}`}
                                onClick={showSearchFrom}
                            >
                                <label className='from-title cursor-pointer'>
                                    <img src={icons.TakeOffPlane} alt='From' />
                                    From</label>
                                <button className='flight_from-search-btn' aria-label="Select City">
                                    <span className='flight-select-title text-truncate'>{selectedFrom?.city ? selectedFrom?.city : "Select City"}</span>
                                    <span className='flight-select-subtitle text-truncate d-block'>{selectedFrom?.name ? selectedFrom?.name : "Country"}</span>
                                </button>
                            </div>


                            {showSearchListFrom && (
                                <div ref={popoverFromRef} className='search-list-container'>
                                    <label className='from-title cursor-pointer'><img src={icons.TakeOffPlane} alt='From' />From</label>
                                    <Input size="large" status={errorSameCitySelect && "error"} className="mb-2" placeholder="From ..." ref={inputRef} prefix={<FaSearch className='mx-1' />}
                                        value={searchTermFrom} onChange={handleInputChange} style={{ height: "60px" }} />
                                    {errorSameCitySelect ? (
                                        <span className='destination-source-error mb-2'>Source and destination cannot be the same</span>
                                    ) : null}
                                    <ul className='search-list my-2'>
                                        {topCityData ? (
                                            <ul className="flight-list">
                                                <span className='mx23'>POPULAR CITIES</span>
                                                {topTanCity?.map((flight, index) => (
                                                    <li key={index} onClick={() => handleSelectFromFlight(flight)} className="flight-item">
                                                        <div className="flight-details">
                                                            <span className="icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                    <g>
                                                                        <path fill="none" d="M0 0h24v24H0z" />
                                                                        <path d="M10.478 11.632L5.968 4.56l1.931-.518 6.951 6.42 5.262-1.41a1.5 1.5 0 0 1 .776 2.898L5.916 15.96l-.776-2.898.241-.065 2.467 2.445-2.626.704a1 1 0 0 1-1.133-.48L1.466 10.94l1.449-.388 2.466 2.445 5.097-1.366zM4 19h16v2H4v-2z" />
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                            <div className="flight-info" style={{ lineHeight: '16px' }}>
                                                                <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                <span className="airportSubTitle">{flight.name}</span><br />
                                                                <span className="airportTitle">{flight.flight_country}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <ul className="flight-list">
                                                <span className='mx23' style={{ textTransform: 'uppercase' }}>Suggested Cities</span>
                                                {flightList?.map((flight, index) => (
                                                    <li key={index} onClick={() => handleSelectFromFlight(flight)} className="flight-item">
                                                        <div className="flight-details">
                                                            <span className="icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                    <g>
                                                                        <path fill="none" d="M0 0h24v24H0z" />
                                                                        <path d="M10.478 11.632L5.968 4.56l1.931-.518 6.951 6.42 5.262-1.41a1.5 1.5 0 0 1 .776 2.898L5.916 15.96l-.776-2.898.241-.065 2.467 2.445-2.626.704a1 1 0 0 1-1.133-.48L1.466 10.94l1.449-.388 2.466 2.445 5.097-1.366zM4 19h16v2H4v-2z" />
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                            <div className="flight-info" style={{ lineHeight: '16px' }}>
                                                                <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                <span className="airportSubTitle">{flight.name}</span><br />
                                                                <span className="airportTitle">{flight.flight_country}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </Col>
                        {/* Exchange Button */}
                        <Button className="exchange_icon" aria-label="Change Flights" id="swap" onClick={handleExchange}>
                            <img src={icons.ExchangeArrow} alt='Exchange Arrow' />
                        </Button>
                        <Col lg={12} xs={12} className='w-100 flight_to_box ps-1'>
                            {/* To Box */}
                            {/* <div className='flight_from cursor-pointer'  */}
                            <div className={`flight_from cursor-pointer ${fieldErrors.to.hasError ? 'flight-field-error' : ''}`}
                                onClick={showSearchTo}
                            >
                                <label className='from-title cursor-pointer'> <img src={icons.LandingPlane} alt='To' />To</label>
                                <button className='flight_from-search-btn' aria-label="Select City">
                                    <span className='flight-select-title text-truncate'>{selectedTo?.city ? selectedTo?.city : "Select City"}</span>
                                    <span className='flight-select-subtitle text-truncate d-block'>{selectedTo?.name ? selectedTo?.name : "Country"}</span>
                                </button>
                            </div>
                            {showSearchListTo && (
                                <div ref={popoverToRef} className='search-list-container'>
                                    <label className='from-title cursor-pointer'> <img src={icons.LandingPlane} alt='To' />To</label>
                                    <Input size="large" status={errorSameCitySelect && "error"} className='mb-2' placeholder="TO ..." ref={inputRef} value={searchTermTo} onChange={handleInputToChange} style={{ height: "60px" }} prefix={<FaSearch className='mx-1' />} />
                                    {errorSameCitySelect ? (
                                        <span className='destination-source-error mb-2'>Source and destination cannot be the same</span>
                                    ) : null}
                                    <ul className='search-list my-2'>
                                        {topCityData ? (
                                            <ul>
                                                {/* {errorSameCitySelect ? (
                                                    <span className='destination-source-error mb-2'>Source and destination cannot be the same</span>
                                                ) : null}<br /> */}
                                                <span className='mx23'>POPULAR CITIES</span>
                                                {topTanCity?.map((flight, index) => (
                                                    <li key={index} onClick={() => handleSelectToFlight(flight)} className="flight-item">
                                                        <div className="flight-details">
                                                            <span className="icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                    <g>
                                                                        <path fill="none" d="M0 0h24v24H0z" />
                                                                        <path d="M10.254 10.47l-.37-8.382 1.933.518 2.81 9.035 5.261 1.41a1.5 1.5 0 1 1-.776 2.898L4.14 11.937l.776-2.898.242.065.914 3.35-2.627-.703a1 1 0 0 1-.74-.983l.09-5.403 1.449.388.914 3.351 5.096 1.366zM4 19h16v2H4v-2z" />
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                            <div className="flight-info" style={{ lineHeight: '16px' }}>
                                                                <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                <span className='airportSubTitle'>{flight?.name}</span><br />
                                                                <span className="airportTitle">{flight.flight_country}</span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>

                                        ) : (
                                            <>
                                                <ul className="flight-list">
                                                    {/* <br /> */}
                                                    <span className='mx23' style={{ textTransform: 'uppercase' }}>Suggested Cities</span>
                                                    {flightList?.map((flight, index) => (
                                                        <li key={index} onClick={() => handleSelectToFlight(flight)} className="flight-item">
                                                            <div className="flight-details">
                                                                <span className="icon">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                                                        <g>
                                                                            <path fill="none" d="M0 0h24v24H0z" />
                                                                            <path d="M10.254 10.47l-.37-8.382 1.933.518 2.81 9.035 5.261 1.41a1.5 1.5 0 1 1-.776 2.898L4.14 11.937l.776-2.898.242.065.914 3.35-2.627-.703a1 1 0 0 1-.74-.983l.09-5.403 1.449.388.914 3.351 5.096 1.366zM4 19h16v2H4v-2z" />
                                                                        </g>
                                                                    </svg>
                                                                </span>
                                                                <div style={{ lineHeight: '16px' }}>
                                                                    <span className="airportTitle">{`${flight?.city} (${flight?.code})`}</span><br />
                                                                    <span className='airportSubTitle'>{flight?.name}</span><br />
                                                                    <span className="airportTitle">{flight.flight_country}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        )}

                                    </ul>
                                </div>
                            )}

                        </Col>

                    </Row>
                    {fieldErrors.from.hasError && fieldErrors.from.message && (
                        <div className="error-message-flight">
                            {fieldErrors.from.message}
                        </div>
                    )}
                    {fieldErrors.to.hasError && fieldErrors.to.message && (
                        <div className="error-message-flight">
                            {fieldErrors.to.message}
                        </div>
                    )}
                    {(validationError || (fieldErrors.from.hasError && fieldErrors.to.hasError && fieldErrors.from.message)) && (
                        <div className="error-message-flight">
                            {validationError || fieldErrors.from.message}
                        </div>
                    )}

                </Col>
                <Col md={24} lg={14} className='from_to_box ps-md-1'>
                    <Row>
                        <Col md={12} xs={24}>
                            <Row>
                                {/* Departure Date Picker */}
                                <Col span={returnFlight !== "multiCity" ? 12 : 24} className="pe-md-1 ps-md-1 w-100 pe-1 d-none d-md-block">
                                    <div className='flight_from' ref={wrapperRef} onClick={handleDivClick} style={{ cursor: 'pointer' }}>
                                        <label>
                                            <img src={icons.Calendar} alt='Departure' />
                                            Departure</label>
                                        <DatePicker
                                            ref={datePickerRef}
                                            variant='bordered'
                                            onChange={onChangeDeparture}
                                            open={isDatePickerOpen}
                                            value={findDay ? dayjs(findDay, dateFormat) : null}
                                            format={dateFormat}
                                            showNow={false}
                                            disabledDate={disabledPastDate}
                                            onOpenChange={(status) => setIsDatePickerOpen(status)}
                                        />
                                        <span>{findDay ? moment(findDay, 'DD/MMM/YYYY').format('dddd') : 'Select Date'}</span>
                                    </div>
                                </Col>

                                {/* Return Date Picker */}
                                {returnFlight !== "multiCity" && (
                                    <Col span={12} className="pe-md-1 ps-md-1 ps-1 w-100 d-none d-md-block">
                                        {returnFlight === "roundTrip" && (
                                            <span className='rxCrossReturn' onClick={crossReturnDate}>
                                                <FaTimes />
                                            </span>
                                        )}
                                        <div className='flight_from position-relative' onClick={roundTrip}>
                                            <div ref={wrapperRefReturn} onClick={handleDivClickReturn} style={{ cursor: 'pointer' }}>
                                                <label>
                                                    <img src={icons.Calendar} alt='Departure' />
                                                    Return</label>
                                                {returnFlight === "roundTrip" ? (
                                                    <>
                                                        <DatePicker
                                                            ref={datePickerRefReturn}
                                                            onChange={onChangeReturn}
                                                            value={findDayRetrun ? dayjs(findDayRetrun, dateFormat) : null}
                                                            format={dateFormat}
                                                            showNow={false}
                                                            open={isDatePickerOpenReturn}
                                                            variant="bordered"
                                                            onOpenChange={(status) =>
                                                                setIsDatePickerOpenReturn(status)
                                                            }
                                                            disabledDate={(current) =>
                                                                current && current.isBefore(dayjs(findDay, dateFormat), 'day')
                                                            }
                                                        />
                                                        <span>{findDayRetrun ? moment(findDayRetrun, 'DD/MMM/YYYY').format('dddd') : 'Select Return Date'}</span>
                                                    </>
                                                ) : (
                                                    <p>Click to add a return flight</p>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                )}

                                {/* mobile View */}
                                {/* Departure Date Picker */}
                                {isMobile && (
                                    <>
                                        <Col span={returnFlight !== "multiCity" ? 12 : 24} className="pe-md-1 ps-md-1 w-100 pe-1 d-md-none">
                                            <div
                                                onClick={() => setIsDrawerOpen(true)}
                                                className="open-calendar-btn select-date"
                                            >
                                                <div className='flight_from' style={{ cursor: 'pointer' }}>
                                                    <label className=''>
                                                        <img src={icons.Calendar} alt='Departure' />
                                                        Departure</label>
                                                    <div>
                                                        {findDay}
                                                    </div>
                                                    {/* <span>{findDay ? moment(findDay, 'YYYY-MM-DD').format('dddd') : 'Select Date'}</span> */}
                                                </div>
                                            </div>
                                            <Drawer
                                                title="Add Departure Date"
                                                placement="bottom"
                                                onClose={() => setIsDrawerOpen(false)}
                                                open={isDrawerOpen}
                                                height="85vh"
                                                // height="100vh"
                                                className="calendar-drawer"
                                                closeIcon={null}
                                                styles={{ header: { textAlign: "right" } }}
                                                extra={
                                                    <div
                                                        type="text"
                                                        onClick={() => setIsDrawerOpen(false)}
                                                        className="custom-close-icon mt-2"
                                                        style={{ color: "#fff" }}
                                                    >
                                                        <FaRegTimesCircle fontSize={25} />
                                                    </div>
                                                }
                                            >
                                                <div className="calendar-container">
                                                    {filteredCalendarData?.map((month, index) => (
                                                        <div key={index} className="month-section">
                                                            <h4 className="month-title">{month.month}</h4>
                                                            <div className="day-labels">
                                                                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                                                    <div key={day} className="day-label">
                                                                        {day}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="dates-grid">
                                                                {month?.days.map((date, idx) => (
                                                                    <div
                                                                        key={idx}
                                                                        className={`date-cell ${!date
                                                                            ? "empty"
                                                                            : date.isBefore(today, "day")
                                                                                ? "disabled"
                                                                                : date.isSame(moment(findDay), "day")
                                                                                    ? "selected"
                                                                                    : ""
                                                                            }`}
                                                                        onClick={() => handleDateSelect(date)}
                                                                    >
                                                                        {date ? (
                                                                            <>
                                                                                <div className="date">{date.format("D")}</div>
                                                                            </>
                                                                        ) : null}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Drawer>
                                        </Col>
                                    </>
                                )}



                                {/* Return Date Picker */}
                                {returnFlight !== "multiCity" && (
                                    <Col span={12} className="pe-md-1 ps-md-1 ps-1 w-100 d-md-none">
                                        {returnFlight === "roundTrip" && (
                                            <div onClick={crossReturnDate}>
                                                <span className='rxCrossReturnMobile' >
                                                    <FaTimes />
                                                </span>
                                            </div>)}
                                        <div
                                            onClick={() => setIsReturnDrawerOpen(true)}
                                            className="select-date"
                                        >

                                            <div className="flight_from" style={{ cursor: 'pointer' }} onClick={roundTrip}>
                                                <label>
                                                    <img src={icons.Calendar} alt='Departure' />
                                                    Return</label>
                                                {returnFlight !== "roundTrip" && (
                                                    <>
                                                        <p>Click to add a return flight</p>
                                                    </>
                                                )}

                                                <div>
                                                    {returnFlight === "roundTrip" && (
                                                        <>
                                                            <div
                                                                onClick={() => setIsReturnDrawerOpen(true)}
                                                                className="select-date"
                                                            >
                                                                {findDayRetrun}
                                                            </div>
                                                            {/* <span>{findDayRetrun ? moment(findDayRetrun, 'YYYY-MM-DD').format('dddd') : 'Select Date'}</span> */}
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                        <>
                                            {returnFlight === "roundTrip" ? (
                                                <Drawer
                                                    title="Add Return Date"
                                                    placement="bottom"
                                                    onClose={() => setIsReturnDrawerOpen(false)}
                                                    open={isReturnDrawerOpen}
                                                    height="85vh"
                                                    className="calendar-drawer"
                                                    closeIcon={null}
                                                    styles={{ header: { textAlign: "right" } }}
                                                    extra={
                                                        <div onClick={() => setIsReturnDrawerOpen(false)} className="custom-close-icon mt-2" style={{ color: '#fff' }}>
                                                            <FaRegTimesCircle fontSize={25} />
                                                        </div>
                                                    }
                                                >
                                                    <div className="calendar-container">
                                                        {filteredReturnCalendarData.map((month, index) => (
                                                            <div key={index} className="month-section">
                                                                <h4 className="month-title">{month.month}</h4>
                                                                <div className="day-labels">
                                                                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                                                        <div key={day} className="day-label">{day}</div>
                                                                    ))}
                                                                </div>
                                                                <div className="dates-grid">
                                                                    {month.days.map((date, idx) => {
                                                                        const departureDate = moment(findDay, "DD/MMM/YYYY");
                                                                        return (
                                                                            <div
                                                                                key={idx}
                                                                                className={`date-cell ${!date
                                                                                    ? "empty"
                                                                                    : date.isBefore(departureDate, "day")
                                                                                        ? "disabled"
                                                                                        : date.isSame(moment(findDayRetrun), "day")
                                                                                            ? "selected"
                                                                                            : ""
                                                                                    }`}
                                                                                onClick={() => handleReturnDateSelect(date)}
                                                                            >
                                                                                {date ? (
                                                                                    <div className="date">{date.format("D")}</div>
                                                                                ) : null}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Drawer>
                                            ) : null}
                                        </>
                                    </Col>
                                )}

                            </Row>
                        </Col>


                        <Col md={returnFlight !== "multiCity" ? 12 : 16} className="ps-md-1 w-100">
                            <Popover
                                content={
                                    <>
                                        <Form className='popup-form '>
                                            <div className='popup-inner'>
                                                <div className='select-adult mb-3'>
                                                    <div>
                                                        <h6 className={infantsError && "destination-source-error"}>Adults</h6>
                                                        <p>(Aged 12+ yrs)</p>
                                                    </div>
                                                    <span className='selection'>
                                                        <Button className='me-3' onClick={removeAdults} aria-label="remove adults"><FaMinus /></Button>
                                                        <span className='me-3'>{selectAdults}</span>
                                                        <Button onClick={addAdults} disabled={passengerLimitReached} style={{ padding: "6px 10px" }} aria-label="add adults"><FaPlus /></Button>
                                                    </span>
                                                </div>

                                                <div className='select-child  mb-3'>
                                                    <div>
                                                        <h6>Children</h6>
                                                        <p>(Aged 2-12 yrs)</p>
                                                    </div>
                                                    <span className='selection'>
                                                        <Button className='me-3' onClick={removeChildern} aria-label="remove child"><FaMinus /></Button>
                                                        <span className='me-3'>{selectchildren}</span>
                                                        <Button disabled={passengerLimitReached} onClick={addChildern} style={{ padding: "6px 10px" }} aria-label="add child"><FaPlus /></Button>
                                                    </span>
                                                </div>

                                                <div className='select-room  mb-3'>
                                                    <div>
                                                        <h6 className={infantsError && "destination-source-error"}>Infants</h6>
                                                        <p>(Below 2 yrs)</p>
                                                    </div>
                                                    <span className='selection'>
                                                        <Button className='me-3' onClick={removeInfants} style={{ padding: "6px 10px" }} aria-label="remove infant"><FaMinus /></Button>
                                                        <span className='me-3'>{selectInfants}</span>
                                                        <Button disabled={infantsError || passengerLimitReached} onClick={addInfants} style={{ padding: "6px 10px" }} aria-label="add infant"><FaPlus /></Button>
                                                    </span>
                                                </div>
                                                {infantsError &&
                                                    <p className='destination-source-error mb-2'>You must have atleast one adult per infant</p>
                                                }
                                                {/* {passengerLimitReached && (
                                                        <p className="destination-source-error mb-2">
                                                            Flights cannot be booked for more then 9 passengers
                                                        </p>
                                                    )} */}
                                                <h4 className='mb-2'>Travel Class</h4>
                                                <Radio.Group defaultValue="ECONOMY" onChange={(e) => setSeatType(e.target.value)}>
                                                    <Radio value="ECONOMY">Economy</Radio>
                                                    <Radio value="PREMIUM_ECONOMY">Premium</Radio>
                                                    <Radio value="BUSINESS">Business</Radio>
                                                    <Radio value="FIRST">First Class</Radio>
                                                </Radio.Group>
                                                <div className='popup-footer'>
                                                    <Button
                                                        disabled={infantsError}
                                                        onClick={() => setOpen(false)}  // This closes the popover when the "Done" button is clicked
                                                        className='w-100 btn btn-primary'
                                                        aria-label="Done Traveller and class"
                                                    >
                                                        Done
                                                    </Button>
                                                </div>

                                            </div>
                                        </Form>
                                    </>
                                }
                                placement="bottom"
                                trigger="click"
                                open={open}
                                onOpenChange={(visible) => setOpen(visible)}
                            >
                                <div style={infantsError ? { borderColor: "red" } : {}} className='flight_from'>
                                    <label>
                                        <img src={icons.Users} alt='Travelers & Class' />
                                        Travelers & Class  </label>

                                    <div className="select-acr"
                                    > {selectAdults} Adults

                                        {selectchildren !== 0 && (
                                            <>
                                                {`, ${selectchildren} Children`}
                                            </>
                                        )}

                                        {selectInfants !== 0 && (
                                            <>
                                                {`, ${selectInfants} Infants`}
                                            </>
                                        )}

                                        <i className='bx bx-chevron-down'></i>
                                    </div>


                                    <span>{travelersClass[seatType]}</span>
                                </div>
                            </Popover>
                        </Col>
                    </Row>
                </Col>

            </Row >

        </>
    )
}

export default SearchBar